import { render, staticRenderFns } from "./OldUsers.vue?vue&type=template&id=40b29b2a&scoped=true&"
import script from "./OldUsers.vue?vue&type=script&lang=js&"
export * from "./OldUsers.vue?vue&type=script&lang=js&"
import style0 from "./OldUsers.vue?vue&type=style&index=0&id=40b29b2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b29b2a",
  null
  
)

export default component.exports